import { axios } from '@/utils/request'
import Vue from 'vue'

let areaListKey = 'mf2.0_local_all_city_list'
import store from '@/store'

export default class CitiesHelper {
  static getAllCities() {
    return new Promise((resolve, reject) => {
      const cityList = Vue.ls.get(areaListKey)//获取本地的所有测试
      if (cityList && cityList.length === 2) {
        resolve(cityList)
      } else {
        axios({
          baseURL: '',
          url: '/AllCity.json',
          method: 'get'
        }).then(cityList => {
          // 保存到本地，缓存七天
          Vue.ls.set(areaListKey, cityList, 30 * 24 * 60 * 60 * 1000)
          resolve(cityList)
        }).catch(reason => {
          reject(reason)
        })
      }
    })
  }

//获取国内城市
  static getDomesticCityList() {
    return new Promise((resolve, reject) => {
      CitiesHelper.getAllCities().then(list => {
        resolve(list[0].children)
      }).catch(reason => reject(reason))
    })
  }

  //获取国外城市
  static getForeignCitList() {
    return new Promise((resolve, reject) => {
      CitiesHelper.getAllCities().then(list => {
        resolve(list[1].children)
      }).catch(reason => reject(reason))
    })
  }
}
